import request from "@/axios";
import type { CompanyInfo, HomeContent, queryParams, newsQueryParams, RecruitInfo } from "./types";
/**
 * 查询公司信息
 */
export const getCompanyInfo = async () => {
  return await request.get<CompanyInfo>({
    url: "/web/getCompanyInfo/1",
  });
};

/**
 * 查询首页内容
 */
export const getHomeContent = async () => {
  return await request.get<HomeContent>({
    url: "/web/getWebHomeValue",
  });
};

/**
 * 查询业务列表
 */
export const getBusinessList = async (data: queryParams) => {
  return await request.get({
    url: "/web/getHomeBusinesList",
    params: data,
  });
};

export const getnewTrends = async (data: newsQueryParams) => {
  return await request.get({
    url: "/web/getnewTrends",
    params: data,
  });
};

/**
 *根据关键字查找新闻
 * @param queryStr
 * @returns
 */
export const getQuaryNew = async (queryStr: string) => {
  return await request.get({
    url: "/web/getQuaryNew/" + queryStr,
    method: "get",
  });
};

export const gePopulartNew = async (data) => {
  return await request.get({
    url: "/web/gePopulartNew",
    method: "get",
    params: data,
  });
};

export async function getRecruitList(data) {
  return await request.get({
    url: "/web/getRecruitList",
    params: data,
  });
}

export const getStationTree = async () => {
  return await request.get({
    url: "/web/getStation",
  });
};

export const getWorkCity = async () => {
  return await request.get({
    url: "/web/getCity",
  });
};

export const getBusinessInfo = async (id: number) => {
  return await request.get({
    url: "/web/getHomeBusinesinfo/" + id,
  });
};

export const getProductInfo = async (id: number) => {
  return await request.get({
    url: "/web/getProductInfo/" + id,
  });
};

export const getnewInfo = async (id: number) => {
  return await request.get({
    url: "/web/getnewInfo/" + id,
  });
};
